import { render, staticRenderFns } from "./WarningModalForEditMail.vue?vue&type=template&id=10356778&scoped=true"
import script from "./WarningModalForEditMail.vue?vue&type=script&lang=js"
export * from "./WarningModalForEditMail.vue?vue&type=script&lang=js"
import style0 from "./WarningModalForEditMail.vue?vue&type=style&index=0&id=10356778&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10356778",
  null
  
)

export default component.exports